<template>
  <v-select
    v-if="userReports.length > 1"
    v-model="selectedUserReportIdModel"
    :items="userReports"
    item-value="attributes.id"
    item-text="attributes.name"
    hide-details
    class="report-selection"
  />
  <v-toolbar-title v-else>
    {{ defaultTitle }}
  </v-toolbar-title>
</template>

<script>
import { useVModel } from '@vueuse/core'

export default {
  props: {
    userReports: {
      type: Array,
      required: true,
      default: () => [],
    },
    selectedUserReportId: {
      type: [String, Number],
      required: true,
    },
    defaultTitle: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const selectedUserReportIdModel = useVModel(props, 'selectedUserReportId', emit)

    return {
      selectedUserReportIdModel,
    }
  },
}
</script>

<style lang="scss">
.report-selection {
  width: min-content;
  .v-select__selections {
    font-size: 1.25rem !important;
    line-height: 1.5 !important;
  }
}
</style>
